import { AnchorHTMLAttributes, forwardRef } from 'react'
import { Link as RLink } from 'react-router-dom'
import {
  Link as MuiLink,
  LinkProps as MuiLinkProps,
} from '@pogokid/mui'
import { useOnClickHrefRouter } from '~m/designSystem'

declare module '@mui/material/Link/Link' {
  interface LinkPropsColorOverrides {
    neutral: true
  }
}

interface LinkProps extends MuiLinkProps {
  href: string
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, ...props }, ref) => {
    return (
      <MuiLink
        component={RLink}
        ref={ref}
        {...props}
        to={href}
      />
    )
  }
)
Link.displayName = 'Link'

export interface RawLinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {}

export const RawLink = forwardRef<
  HTMLAnchorElement,
  RawLinkProps
>(({ href, ...props }, ref) => {
  const onClick = useOnClickHrefRouter(href ?? '')
  return <a ref={ref} {...props} href={href} onClick={onClick} />
})
RawLink.displayName = 'RawLink'
